// Help System guide catalogue.
// Plain trade English. Max 5 steps per guide. No software terms.
// Add new guides here — the panel picks them up automatically.

export const HELP_GUIDES = [
  {
    id: "create-enquiry",
    title: "Create an enquiry",
    when: "The phone rings. Someone wants a quote.",
    icon: "Phone",
    keywords: ["enquiry", "lead", "phone", "new customer", "call"],
    steps: [
      "On Home, tap the red \"+ New enquiry\" button at the top.",
      "Type the customer's name, phone and email.",
      "Type the address — street, suburb, postcode.",
      "Write one or two lines about the job.",
      "Tap \"Create enquiry\". You're done — the enquiry appears in the list.",
    ],
  },
  {
    id: "book-site-visit",
    title: "Book a site visit",
    when: "The customer is ready to show you the roof.",
    icon: "Clipboard",
    keywords: ["site visit", "survey", "book", "measure", "inspection"],
    steps: [
      "Open the enquiry from the Enquiries list.",
      "Tap the red \"Book site visit\" button.",
      "The Site Visit form opens — the customer's address is already filled in.",
      "Save and exit. The job moves to \"Site visit booked\" on its own.",
      "Later: open the same site visit on your phone when you're on the roof.",
    ],
  },
  {
    id: "complete-site-visit",
    title: "Finish a site visit on the roof",
    when: "You're at the property with measurements in hand.",
    icon: "Roof",
    keywords: ["measurements", "complete", "finish", "roof", "photos", "voice"],
    steps: [
      "Open Site Visits → tap the one you're working on.",
      "Move through the tabs at the top — Site, Roof, Measurements, Photos.",
      "Type the roof area, gutter length, anything that matters.",
      "Take photos of the roof, gutters and any defects you see.",
      "On the \"Finalise\" tab, tap \"Finish the site visit\". It's locked and ready for a quote.",
    ],
  },
  {
    id: "create-quote",
    title: "Create a quote",
    when: "The site visit is done and the customer wants pricing.",
    icon: "FileText",
    keywords: ["quote", "price", "estimate", "draft", "cost"],
    steps: [
      "Open the finished site visit.",
      "Tap the big \"Create quote from site visit\" button.",
      "Review the lines the system pre-filled from your measurements.",
      "Tap \"Create quote draft\". The quote opens in the builder.",
      "Adjust quantities or items, then save.",
    ],
  },
  {
    id: "send-quote",
    title: "Send the quote to the customer",
    when: "The quote is ready and the price is right.",
    icon: "Send",
    keywords: ["send", "email", "quote", "customer", "deliver"],
    steps: [
      "Open the quote.",
      "Toggle to \"Customer preview\" (top right) to check what the customer will see.",
      "Tap \"Mark sent\" once you've sent the PDF to the customer.",
      "A follow-up reminder is added to your chasing list for 5 days later.",
      "When the customer accepts, come back and tap \"Won\".",
    ],
  },
  {
    id: "record-deposit",
    title: "Record a deposit",
    when: "The customer has paid the deposit.",
    icon: "Banknote",
    keywords: ["deposit", "money", "payment", "received", "paid"],
    steps: [
      "Open the job.",
      "Go to the \"Money\" tab.",
      "Tap \"Record\" in the Deposit panel.",
      "Type the amount the customer paid and tap save.",
      "The job moves to \"Ready to schedule\" by itself.",
    ],
  },
  {
    id: "schedule-job",
    title: "Schedule a job",
    when: "The deposit is in and you need to book the crew.",
    icon: "Calendar",
    keywords: ["schedule", "book", "crew", "calendar", "date", "diary"],
    steps: [
      "Open the Schedule from the sidebar.",
      "Find the job in the unassigned column on the right.",
      "Drag it onto the crew row and day you want.",
      "Double-tap the block to add notes or change duration.",
      "Done — the office and the crew now see the same booking.",
    ],
  },
  {
    id: "complete-job",
    title: "Sign off a finished job",
    when: "The crew has finished on site and the customer is happy.",
    icon: "Check",
    keywords: ["complete", "sign off", "signature", "done", "finish"],
    steps: [
      "Open the job from \"My Day\" or Jobs.",
      "Tap \"Practical completion\".",
      "Hand the phone to the customer.",
      "Customer types their name and signs on the screen.",
      "Tap save — the office sees the sign-off on Home tomorrow morning.",
    ],
  },
  {
    id: "final-invoice",
    title: "Raise the final invoice",
    when: "The job is signed off and you need to invoice the rest.",
    icon: "Receipt",
    keywords: ["invoice", "final", "bill", "money owed", "raise"],
    steps: [
      "Open the job.",
      "Go to the \"Money\" tab.",
      "Tap \"Add\" next to Final invoice.",
      "Type the remaining amount and the invoice number from your accounting software.",
      "Save. If the customer hasn't been signed off yet, the system will block you and ask for that first.",
    ],
  },
  {
    id: "upload-photos",
    title: "Upload photos to a job",
    when: "You're on site and need to add photos.",
    icon: "Camera",
    keywords: ["photos", "upload", "pictures", "camera", "before", "after"],
    steps: [
      "Open the site visit or the job from \"My Day\".",
      "Tap the \"Photos & Voice\" tab (site visit) or \"Photos\" section (job).",
      "Tap \"Add photo\" and choose Camera.",
      "Take the photo. It uploads in the background — keep working.",
      "When the green tick appears, the photo is safe at the office.",
    ],
  },
  {
    id: "find-customer",
    title: "Find a customer again",
    when: "You need to look someone up.",
    icon: "Search",
    keywords: ["customer", "find", "search", "lookup", "directory"],
    steps: [
      "Open \"Customers\" from the sidebar.",
      "Type any part of the name, phone or address in the search box.",
      "Tap the customer in the list.",
      "You'll see every enquiry, quote and job for that customer in one place.",
      "From here you can ring them, open any of their jobs, or create a new enquiry.",
    ],
  },
];
